<div class="col-12 mt-2">
  <app-property-equipment-table #equipmentTable [prop]="prop"></app-property-equipment-table>
</div>
<div class="col-12 mt-2">
  <app-property-doc-view *ngIf="equipmentTable.rawData" [prop]="prop" [category]="category"
    [equipments]="equipmentTable.rawData">
  </app-property-doc-view>
</div>
